import { Icon } from './Icon';

interface PageHeaderProps {
  icon: string;
  title: string;
  subtitle?: string;
}

/**
 * The centred icon, title and subtitle at the top of Alerts, Contact us and
 * Disclaimers. Replaces three copies of the same .page-header markup and SCSS;
 * the icon is 48px in brand orange, 40px on phones, as before.
 */
export function PageHeader({ icon, title, subtitle }: PageHeaderProps) {
  return (
    <header className="text-center">
      <Icon icon={icon} className="mx-auto mb-4 size-10 text-primary md:size-12" />
      <h1 className="text-2xl font-semibold text-content">{title}</h1>
      {subtitle && <p className="mt-1 text-muted">{subtitle}</p>}
    </header>
  );
}
